// @ts-nocheck
import * as React from "react";

const TrashLine: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M6 20V6H5V5h4v-.769h6v.77h4v1h-1v14H6Zm1-1h10V6H7v13Zm2.808-2h1V8h-1v9Zm3.384 0h1V8h-1v9Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(TrashLine);
